module.exports = __webpack_public_path__ + "static/media/P1-Tienda-sin-articulos-imagen.40aea664.png";